export default __webpack_public_path__ + "static/tag-dont-4-dark-51381858235973e6c4a6ea0aa4c7e3c5.png";